export default __webpack_public_path__ + "static/media/AVIO.c1e771f9.jpg";